<div class="">
  <app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
  <div class="row mt-3">
    <div class="col-md-3 text-left text-link">
      <div class="text-blue" *ngIf="(regulations.data && (regulations.data.length>0))">
        <div>{{endIndex}} out of {{regulations.totalCount}}</div>
      </div>
    </div>
    <div class="col-md-9 mb-2">
      <span class="text-capitalize pl-3 pull-right" *ngIf="regulationFilter.FilterType !== 'Future Updates'" dropdown
        #dropdown="bs-dropdown" [insideClick]="true" [autoClose]="false">
        <span dropdownToggle class="dropdown-toggle cursor-pointer text-blue">
          Filters <span class="caret"></span>
        </span>
        <div class="row" style="margin-left: 0; margin-right: 0;">
          <div id="dropdown-triggers-manual" *dropdownMenu class="dropdown-menu col-md-12 p-3" role="menu"
            aria-labelledby="button-triggers-manual">
            <app-regulatory-filters [filterPersistenceKey]="filterPersistenceKey" [ruleTypeName]=""
              (OnFilter)="OnFilter($event)">
            </app-regulatory-filters>
          </div>
        </div>
      </span>
      <span class="pull-right text-blue pl-3" (click)="bulkClose()"
        *ngIf="regulationFilter.FilterType !== 'Actioned'">Bulk
        Close</span>
      <span class="pull-right text-blue" (click)="deleteLinkedUpdates()">Delete</span>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="table-responsive box-shadow">
        <table class="table table-fixed mb-0" id="regulation-table" style="min-width: 1000px">
          <thead style="padding-right: 5px;">
            <tr>
              <th class="pointer col-lg-1 mx-width-8pr text-center">
                <i class="fa fa-square-o icon-font" (click)="selectAllItem('Checked')"
                  *ngIf="selectedItems.length === 0" aria-hidden="true"></i>
                <i class="fa fa-check-square icon-font" (click)="selectAllItem('UnChecked')"
                  *ngIf="selectedItems.length > 0" aria-hidden="true"></i>
                <span style="margin-left:20px" (click)="sortRegulations('Id')">Id
                  <i class="fa" [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'Id' && !regulationFilter.IsDesc),
                  'fa-sort-amount-desc': (regulationFilter.SortKey === 'Id' && regulationFilter.IsDesc) }"
                    aria-hidden="true">
                  </i>
                </span>
              </th>
              <th class="pointer col-lg-1 mx-width-8pr" (click)="sortRegulations('Geography')">Geography
                <i class="fa" [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'Geography' && !regulationFilter.IsDesc),
                  'fa-sort-amount-desc': (regulationFilter.SortKey === 'Geography' && regulationFilter.IsDesc) }"
                  aria-hidden="true">
                </i>
              </th>
              <th class="pointer col-lg-1 mx-width-7pr" (click)="sortRegulations('Country')">Country
                <i class="fa" [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'Country' && !regulationFilter.IsDesc),
                  'fa-sort-amount-desc': (regulationFilter.SortKey === 'Country' && regulationFilter.IsDesc) }"
                  aria-hidden="true">
                </i>
              </th>
              <th class="pointer col-lg-1 mx-width-8pr" (click)="sortRegulations('Regulator')">Regulator
                <i class="fa" [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'Regulator' && !regulationFilter.IsDesc),
                  'fa-sort-amount-desc': (regulationFilter.SortKey === 'Regulator' && regulationFilter.IsDesc) }"
                  aria-hidden="true">
                </i>
              </th>
              <th class="pointer col-lg-1 mx-width-11pr" (click)="sortRegulations('Date')">Publish Date
                <i class="fa" [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'Date' && !regulationFilter.IsDesc),
                  'fa-sort-amount-desc': (regulationFilter.SortKey === 'Date' && regulationFilter.IsDesc) }"
                  aria-hidden="true">
                </i>
              </th>
              <th class="pointer col-lg-1 mx-width-15pr" (click)="sortRegulations('Title')">Title
                <i class="fa" [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'Title' && !regulationFilter.IsDesc),
                    'fa-sort-amount-desc': (regulationFilter.SortKey === 'Title' && regulationFilter.IsDesc) }"
                  aria-hidden="true">
                </i>
              </th>
              <th class="pointer col-lg-2"
                [ngClass]="regulationFilter.FilterType === 'Actioned' ? 'mx-width-11pr' : 'mx-width-13pr'">
                <span (click)="sortRegulations('PubType')">
                  Type
                  <span class="fa" [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'PubType' && !regulationFilter.IsDesc),
                    'fa-sort-amount-desc': (regulationFilter.SortKey === 'PubType' && regulationFilter.IsDesc) }"
                    aria-hidden="true">
                  </span>
                </span>
                <span dropdown [insideClick]="true" [autoClose]="true">
                  <span class="fa fa-filter p-1 ml-2 border"
                    [ngClass]="selectedPubTypeSubFilters.length>0?'text-blue border-primary':''" id="button-basic"
                    dropdownToggle aria-controls="dropdown-basic">
                  </span>
                  <div id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu"
                    aria-labelledby="button-basic" style="max-height: 150px; overflow-y: auto; max-width: 225px;">
                    <div class="form-group p-2 mb-0">
                      <mat-chip-list #pubTypeSubList>
                        <ng-container *ngFor="let subType of selectedPubTypeSubFilters">
                          <mat-chip [selectable]="selectable" [removable]="removable"
                            (removed)="removeSubType(subType)">
                            {{subType}}
                            <mat-icon matChipRemove>x</mat-icon>
                          </mat-chip>
                        </ng-container>
                        <input class="form-control form-control-sm mat-autodd-input border-bottom" #pubTypeSubInput
                          [formControl]="pubTypeSubCntrl" [matAutocomplete]="pubTypeSubAutocomplete"
                          [matChipInputFor]="pubTypeSubList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                          [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addSubType($event)">
                      </mat-chip-list>
                      <mat-autocomplete #pubTypeSubAutocomplete="matAutocomplete"
                        (optionSelected)="selectSubType($event)">
                        <mat-option *ngFor="let subType of searchedSubType" [value]="subType">
                          {{subType}}
                        </mat-option>
                      </mat-autocomplete>
                    </div>
                  </div>
                </span>
              </th>
              <th class="col-lg-2" scope="col"
                [ngClass]="regulationFilter.FilterType === 'Actioned' ? 'mx-width-8pr' : 'mx-width-11pr'">
                <span>Topic</span>
              </th>
              <th class="col-lg-1 mx-width-9pr" scope="col" *ngIf="regulationFilter.FilterType === 'Actioned'">
                <span>Division</span>
              </th>
              <th class="col-lg-1 mx-width-7pr text-lg-center" *ngIf="regulationFilter.FilterType === 'Open'"
                scope="col">
                <span>Status</span>
              </th>
              <th class="pointer col-lg-1 mx-width-7pr text-lg-center"
                *ngIf="regulationFilter.FilterType === 'Actioned'" (click)="sortRegulations('Status')">Status
                <i class="fa" [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'Status' && !regulationFilter.IsDesc),
                    'fa-sort-amount-desc': (regulationFilter.SortKey === 'Status' && regulationFilter.IsDesc) }"
                  aria-hidden="true">
                </i>
              </th>
              <th class="col-lg-1 text-lg-center"
                [ngClass]="regulationFilter.FilterType === 'Actioned' ? 'mx-width-8pr' : 'mx-width-9pr'" scope="col">
                Actions</th>
            </tr>
          </thead>
          <app-progress-bar [isLoading]="isLoadingRegulations"></app-progress-bar>
          <tbody *ngIf="(regulations.data && (regulations.data.length>0))" [style.max-height.px]="myInnerHeight">
            <cdk-virtual-scroll-viewport class="list-container list-group" itemSize="35"
              (scrolledIndexChange)="handler($event)" [style.height.px]="myInnerHeight" *ngIf="regulations.data">
              <div *cdkVirtualFor="let item of regulations.data; let i = index">
                <tr [ngClass]="{'table-row' : item.isGreaterThanTodayDate, 'tr-bold' : item.status === 'Open',
                  'selected-row': selectedItemId > 0 && selectedItemId === item.id}"
                  (click)="selectedItemId = item.id">
                  <td class="col-lg-1 mx-width-8pr" scope="row">
                    <i class="fa fa-square-o icon-font" (click)="selectItem('Checked', item.id)"
                      *ngIf="!getSelectedItems(item.id)" aria-hidden="true"></i>
                    <i class="fa fa-check-square icon-font" (click)="selectItem('UnChecked', item.id)"
                      *ngIf="getSelectedItems(item.id)" aria-hidden="true"></i>
                    {{item.id}}
                  </td>
                  <td class="col-lg-1 mx-width-8pr tbl-td-scroll" scope="row">{{item.geography}}</td>
                  <td class="col-lg-1 mx-width-7pr tbl-td-scroll" scope="row">{{item.country}}</td>
                  <td class="col-lg-1 mx-width-8pr tbl-td-scroll" scope="row">{{item.regulator}}</td>
                  <td class="col-lg-1 mx-width-11pr tbl-td-scroll" scope="row">{{item.date}}</td>
                  <td class="col-lg-1 mx-width-15pr tbl-td-scroll" title="{{ item.description }}" scope="row">{{
                    item.title}}</td>
                  <td class="col-lg-2 tbl-td-scroll" scope="row" [innerHTML]="item.pubType"
                    [ngClass]="regulationFilter.FilterType === 'Actioned' ? 'mx-width-11pr' : 'mx-width-13pr'"></td>
                  <td class="col-lg-2 mx-width-8pr tbl-td-scroll" scope="row" [innerHTML]="item.ruleTopic"
                    [ngClass]="regulationFilter.FilterType === 'Actioned' ? 'mx-width-8pr' : 'mx-width-11pr'"></td>
                  <td class="col-lg-1 mx-width-9pr tbl-td-scroll" *ngIf="regulationFilter.FilterType === 'Actioned'"
                    scope="row" [innerHTML]="item.jurisdiction"></td>
                  <td class="col-lg-1 mx-width-7pr text-lg-center tbl-td-scroll" scope="row">
                    {{ item.status }}
                  </td>
                  <td class="col-lg-1 pull-right text-lg-center"
                    [ngClass]="regulationFilter.FilterType === 'Actioned' ? 'mx-width-8pr' : 'mx-width-9pr'">
                    <a [routerLink]="['/library/rule-detail/']" [queryParams]="{ id: item.id, detailType: 3 }">View
                      |</a>
                    <a href="{{item.hyperlink}}" target="_blank"> Link |</a>
                    <a class="text-muted disable-link"> Assess | </a>
                    <a *ngIf="regulationFilter.FilterType !== 'Actioned'" (click)="openDialog(item)"> Close</a>
                    <span class="text-muted cursor-default"
                      *ngIf="regulationFilter.FilterType === 'Actioned' && !checkJurisdictionPermission(item.jurisdiction)">
                      Edit</span>
                    <span *ngIf="regulationFilter.FilterType === 'Actioned'
                    && checkJurisdictionPermission(item.jurisdiction)">
                      <a *ngIf="item.regulationDetails && item.regulationDetails.id > 0 && !item.impactAssessmentStatus"
                        (click)="openDialog(item)">Edit</a>
                      <span class="text-muted cursor-default" *ngIf="item.impactAssessmentStatus">
                        Edit</span>
                    </span>
                  </td>
                </tr>
              </div>
            </cdk-virtual-scroll-viewport>
          </tbody>
          <tbody *ngIf="(!regulations.data || !(regulations.data.length>0)) && isRegulationFetched">
            <tr>
              <td colspan="9">No data found</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-md-12 col-lg-12" *ngIf="isLoadingPagination">
      <div class="col-md-12 col-lg-3 p-0 mt-2 pull-right">
        <app-progress-bar [isLoading]="true"></app-progress-bar>
      </div>
    </div>
  </div>
</div>
